import React from 'react';

import './Entry.css';
import TwoColumn from '../components/TwoColumn.jsx';

import img from '../images/wallpaperGradient.png';
import codHeaderImg from '../images/codGradient.png';
import codScreenshot from '../images/codScreenshot.png';
import codHavocIcons from '../images/HavocIcons.png';
import codPerkIcons from '../images/PerkIcons2.png';
import codFigmaDesignLibrary from '../images/FigmaDesignLibrary.gif';
import codVictoryAnim from '../images/VictoryAnim.gif';


function cod_rs(headerVar) {

    return(
         <div className='cod_rs'>
               <script>
               window.onload = function() {
                   document.body.style.backgroundImage = `url(${codHeaderImg})`
               };
           </script>
           <script>
               window.onload = function2() {
                   document.body.style.backgroundRepeat = "no-repeat"
               };
           </script>
           <script>
                window.onload = function3() {
                window.scrollTo(0, 0)
                };
           </script>
       
           {/* INTRO DESCRIPTION */}
           <e-h1>Creating UI Art for Call of Duty</e-h1>
           <p> </p>
           <e-h2>UI/UX Design Intern</e-h2>
           <p> </p>
           <p>Learning the process of creating icons, victory animations, and other UI elements for a triple-A shooter game.</p>
           
           {/* CONTEXT DESCRIPTION */}
           <hr class="divider1"></hr>
           <e-h2>How do we <strong>design assets</strong> to be easily understood by players during <strong>fast-paced gameplay</strong>? </e-h2>

            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Product: </strong> </p>
                        <p className = 'twoCol-description'>Call of Duty is a military first-person shooter game. Modern Warfare III is the third installment of Modern Warfare trilogy, and contains three game modes: Campaign, Multiplayer, and Zombies.
</p>
                        <p className = 'twoCol-description'>Raven Software, the studio I interned at, worked on the development of the Multiplayer game mode. 
</p>
                    
                </div> 
        
                <div className='twoCol-img'>
                        <img src={codScreenshot} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>
            
            {/* GOAL SECTION */}
            <hr class="divider1"></hr>
            <e-h2><strong>Goal:</strong> create various new Havoc and Perk icons for the game; all icons must be <strong>square and readable</strong> at a very small size </e-h2>
           
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Havoc Icons</strong> </p>
                        <p className = 'twoCol-description'>I started off with depictions of equipment, but depictions of effects are often more readable. I learned that icons don’t have to be too literal, particularly with icon D3; focusing more on the effect of a snapshot grenade (highlighting enemy silhouettes, like radar) rather than the shape of the physical grenade.
</p>
                        <p className = 'twoCol-description'>Line width affects readability; thicker lines help icons read at a glance, and consistency with pixel width helps multiple icons feel cohesive together.
</p>
                    
                </div> 
        
                <div className='twoCol-img'>
                        <img src={codHavocIcons} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>
            <hr class="divider2"></hr>
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Perk Icons</strong> </p>
                        <p className = 'twoCol-description'>Perk Icons had more values allowed in their style, so balancing detail  became a bit more involved, in addition to shape and composition.
</p>
                        <p className = 'twoCol-description'>Visual language consistency between similar effects was also used more. This  can be seen in several icons, but standouts include A5, A1, and C3.  Based on the visual language of the Fast Hands perk from MWII, perks  relating to speed all utilize a fading silhouette. 
</p>
                    
                </div> 
        
                <div className='twoCol-img'>
                        <img src={codPerkIcons} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>

            {/* ADDITIONAL SECTION */}
            <hr class="divider1"></hr>
            <e-h2><strong>Additional Tasks:</strong></e-h2>
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Recreate existing assets for the Figma Library</strong> </p>
                        <p className = 'twoCol-description'>One of my tasks was to recreate existing assets to be vectorized, editable, and then to add them to a Figma Library.
</p>
                        <p className = 'twoCol-description'>The Figma Library allows for UX designers to pull the assets they need and configure them into widgets for hi-fi mockups. 
</p>
                        <p className = 'twoCol-description'>The biggest challenge was figuring out how to set up frames and layers to  make the dynamic resizing work, especially with multiple strokes and  smooth gradients.
</p>
                        <p className = 'twoCol-description'>Assets also had set properties so the states of buttons or the type of icon could be easily switched between in the final asset.
</p>
                </div> 
        
                <div className='twoCol-img'>
                        <img src={codFigmaDesignLibrary} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>
            <hr class="divider2"></hr>
            <TwoColumn>
                <div className='twoCol-text'>
                        <p> </p>
                        <p className = 'twoCol-description'><strong>Victory/Defeat Animation</strong> </p>
                        <p className = 'twoCol-description'>The task for the victory/defeat animations was to take existing After Effects files and alter some details to fit the new game.
</p>
                        <p className = 'twoCol-description'>The main challenge was learning to navigate After Effects and use advanced features to design efficiently. 
</p>
                        <p className = 'twoCol-description'>I especially learned a lot to do with nesting pre-compositions, expressions, controllers.
</p>
                        <p className = 'twoCol-description'>It was also interesting to explore the visual style of the new game, which involved a lot of glitch effects, chromatic aberration, and scanline and halftone textures.
</p>
                </div> 
        
                <div className='twoCol-img'>
                        <img src={codVictoryAnim} alt="" className='twoCol-image' /> 
                </div>
        
            </TwoColumn>

            <hr class="divider3"></hr>
            <hr class="divider3"></hr>
            </div>
    )
}

export default cod_rs


// WEBPACK FOOTER //
// ./src/pages/cod_rs.jsx